{
  "navigation": {
    "overview": "Overview",
    "diesel": "Diesel",
    "petrol": "Petrol",
    "revolvingBalances": "Carried balances",
    "purchases": "Purchases",
    "sales": "Sales",
    "debtMovements": "Debt sales",
    "payments": "Payments",
    "receipts": "Receipts",
    "debtors": "Debtors",
    "closes": "Shift closes",
    "sendMessage": "Send a message",
    "trash": "Trash",
    "settings": "Settings",
    "settingsPrices": "Prices and settings",
    "settingsCategories": "Categories",
    "settingsYears": "Year management",
    "settingsUsers": "Users",
    "settingsGroups": "Groups",
    "pdaCustomers": "Purchase customers",
    "settingsNationalities": "Nationalities",
    "pendingTransactions": "Pending transactions"
  },
  "sidebar": {
    "title": "Sidebar",
    "description": "Navigation menu",
    "toggleHint": "Toggle navigation (Ctrl/Cmd+B)",
    "toggle": "Toggle sidebar"
  },
  "user": {
    "notifications": "Notifications"
  },
  "documentTitle": "Fuel - Dashboard",
  "nav": {
    "changeBranch": "Change branch",
    "systems": "Systems"
  }
}
